"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DKcourts = void 0;
exports.DKcourts = [
    {
        courtId: '7da6044b-7010-4471-a567-182e3e505c1f',
        name: 'Retten i Hjørring',
        phone: '99685600',
        email: 'foged.hjo@domstol.dk',
        emailFogedret: 'foged.hjo@domstol.dk',
        emailFogedretRevideretBPK: 'foged.hjo@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.hjo@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.hjo@domstol.dk',
        eanno: '5798000162051',
        address: 'Sct Knuds Park 8',
        zipcode: '9800',
        city: 'Hjørring',
        id: '1183',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069136540',
    },
    {
        courtId: 'dc2c41bb-1f7d-42aa-9ce7-81500d6c5bc8',
        name: 'Retten i Aalborg',
        phone: '99688400',
        email: 'foged.alb@domstol.dk',
        emailFogedret: 'foged.alb@domstol.dk',
        emailFogedretRevideretBPK: 'foged.alb@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.alb@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.alb@domstol.dk',
        eanno: '5798000162006',
        address: 'Badehusvej 17',
        zipcode: '9000',
        city: 'Aalborg',
        id: '1178',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133444',
    },
    {
        courtId: '6a07f5da-b0f4-4cc9-88ce-6c5bd7ce8313',
        name: 'Retten i Randers',
        phone: '99688600',
        email: 'foged.ran@domstol.dk',
        emailFogedret: 'foged.ran@domstol.dk',
        emailFogedretRevideretBPK: 'foged.ran@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.ran@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.ran@domstol.dk',
        eanno: '5798000161924',
        address: 'Nørregade 1',
        zipcode: '8900',
        city: 'Randers',
        id: '1169',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133495',
    },
    {
        courtId: 'a5e87914-1b7f-47f6-a97f-da636997e265',
        name: 'Retten i Aarhus',
        phone: '99687800',
        email: 'foged.arh@domstol.dk',
        emailFogedret: 'foged.arh@domstol.dk',
        emailFogedretRevideretBPK: 'foged.arh@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.arh@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.arh@domstol.dk',
        eanno: '5798000161887',
        address: 'Vester Allé 10',
        zipcode: '8000',
        city: 'Aarhus C',
        id: '1165',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133568',
    },
    {
        courtId: '2bbb34b3-e5a2-4f78-a111-5f401b324ce0',
        name: 'Retten i Viborg',
        phone: '99683000',
        email: 'foged.vib@domstol.dk',
        emailFogedret: 'foged.vib@domstol.dk',
        emailFogedretRevideretBPK: 'foged.vib@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.vib@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.vib@domstol.dk',
        eanno: '5798000161948',
        address: 'Klostermarken 10',
        zipcode: '8800',
        city: 'Viborg',
        id: '1171',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133649',
    },
    {
        courtId: '4cfa4c10-1991-4e32-af67-7c9edc436cb6',
        name: 'Retten i Holstebro',
        phone: '99685400',
        email: 'foged.hol@domstol.dk',
        emailFogedret: 'foged.hol@domstol.dk',
        emailFogedretRevideretBPK: 'foged.hol@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.hol@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.hol@domstol.dk',
        eanno: '5798000161856',
        address: 'Stationsvej 58',
        zipcode: '7500',
        city: 'Holstebro',
        id: '1162',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133681',
    },
    {
        courtId: '213bf6ea-597e-41d2-964b-5c85f7b8ddde',
        name: 'Retten i Herning',
        phone: '99686000',
        email: 'foged.her@domstol.dk',
        emailFogedret: 'foged.her@domstol.dk',
        emailFogedretRevideretBPK: 'foged.her@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.her@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.her@domstol.dk',
        eanno: '5798000161825',
        address: 'Haraldsgade 28',
        zipcode: '7400',
        city: 'Herning',
        id: '1159',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133762',
    },
    {
        courtId: 'cf41d8c6-5360-40e8-bb98-4cdb83c9bf44',
        name: 'Retten i Horsens',
        phone: '99683604',
        email: 'foged.hrs@domstol.dk',
        emailFogedret: 'foged.hrs@domstol.dk',
        emailFogedretRevideretBPK: 'foged.hrs@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.hrs@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.hrs@domstol.dk',
        eanno: '5798000161801',
        address: 'Godsbanegade 2',
        zipcode: '8700',
        city: 'Horsens',
        id: '1157',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133819',
    },
    {
        courtId: '4c4e5983-7bac-4949-9fce-e7c8d018607b',
        name: 'Retten i Kolding',
        phone: '99686800',
        email: 'foged.kol@domstol.dk',
        emailFogedret: 'foged.kol@domstol.dk',
        emailFogedretRevideretBPK: 'foged.kol@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.kol@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.kol@domstol.dk',
        eanno: '5798000161788',
        address: 'Kolding Åpark 11',
        zipcode: '6000',
        city: 'Kolding',
        id: '1155',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133851',
    },
    {
        courtId: 'b860114c-43e5-4a5e-9465-067deb3ba3b1',
        name: 'Retten i Esbjerg',
        phone: '99688800',
        email: 'foged.esb@domstol.dk',
        emailFogedret: 'foged.esb@domstol.dk',
        emailFogedretRevideretBPK: 'foged.esb@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.esb@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.esb@domstol.dk',
        eanno: '5798000161740',
        address: 'Dokken 1',
        zipcode: '6700',
        city: 'Esbjerg',
        id: '1151',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133916',
    },
    {
        courtId: '8380c680-a648-4ad7-948b-34c625e0b77d',
        name: 'Retten i Sønderborg',
        phone: '99683850',
        email: 'foged.son@domstol.dk',
        emailFogedret: 'betpk.son@domstol.dk',
        emailFogedretRevideretBPK: 'betpk.son@domstol.dk',
        emailFogedretIndleveringBPK: 'betpk.son@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'betpk.son@domstol.dk',
        eanno: '5798000161696',
        address: 'Stationsvej 10',
        zipcode: '6400',
        city: 'Sønderborg',
        id: '1147',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069133959',
    },
    {
        courtId: '6719b705-f1ee-4fe9-9441-1a42495253ba',
        name: 'Retten i Odense',
        phone: '99683400',
        email: 'foged.ode@domstol.dk',
        emailFogedret: 'foged.ode@domstol.dk',
        emailFogedretRevideretBPK: 'foged.ode@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.ode@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.ode@domstol.dk',
        eanno: '5798000161580',
        address: 'Albanigade 28',
        zipcode: '5000',
        city: 'Odense',
        id: '1135',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134041',
    },
    {
        courtId: 'd66c13a6-70d5-4726-8124-e1eb2cd2db66',
        name: 'Retten i Svendborg',
        phone: '99683200',
        email: 'foged.sve@domstol.dk',
        emailFogedret: 'foged.sve@domstol.dk',
        emailFogedretRevideretBPK: 'foged.sve@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.sve@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.sve@domstol.dk',
        eanno: '5798000161603',
        address: 'Christiansvej 41',
        zipcode: '5700',
        city: 'Svendborg',
        id: '1137',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134106',
    },
    {
        courtId: '7b1c7478-30f8-4171-beed-cdbc42d58f82',
        name: 'Retten i Nykøbing Falster',
        phone: '99684400',
        email: 'foged.nyk@domstol.dk',
        emailFogedret: 'foged.nyk@domstol.dk',
        emailFogedretRevideretBPK: 'foged.nyk@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.nyk@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.nyk@domstol.dk',
        eanno: '5798000161542',
        address: 'Vestensborg Alle 8',
        zipcode: '4800',
        city: 'Nykøbing Falster',
        id: '1131',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134165',
    },
    {
        courtId: '6bc3e64d-4c43-411b-9de5-e9767d8960d1',
        name: 'Retten i Næstved',
        phone: '99685200',
        email: 'foged.nae@domstol.dk',
        emailFogedret: 'foged.nae@domstol.dk',
        emailFogedretRevideretBPK: 'foged.nae@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.nae@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.nae@domstol.dk',
        eanno: '5798000161528',
        address: 'Gardehusarvej 5',
        zipcode: '4700',
        city: 'Næstved',
        id: '1129',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134238',
    },
    {
        courtId: '0ef0a278-6161-45d6-a9ef-45cf4d964ce7',
        name: 'Retten i Holbæk',
        phone: '59490712',
        email: 'foged.hbk@domstol.dk',
        emailFogedret: 'foged.hbk@domstol.dk',
        emailFogedretRevideretBPK: 'foged.hbk@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.hbk@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.hbk@domstol.dk',
        eanno: '5798000161443',
        address: 'Domhusstræde 1',
        zipcode: '4300',
        city: 'Holbæk',
        id: '1122',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134262',
    },
    {
        courtId: 'f82b819f-9ca1-4a81-8832-d5424cb5b4d9',
        name: 'Retten i Roskilde',
        phone: '99687600',
        email: 'foged.ros@domstol.dk',
        emailFogedret: 'foged.ros@domstol.dk',
        emailFogedretRevideretBPK: 'foged.ros@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.ros@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.ros@domstol.dk',
        eanno: '5798000161429',
        address: 'Ved Ringen 1',
        zipcode: '4000',
        city: 'Roskilde',
        id: '1118',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134327',
    },
    {
        courtId: '7bfe9a44-dbcb-48ac-9d05-d249e866b7f7',
        name: 'Retten i Hillerød',
        phone: '47338700',
        email: 'foged.hil@domstol.dk',
        emailFogedret: 'foged.hil@domstol.dk',
        emailFogedretRevideretBPK: 'foged.hil@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.hil@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.hil@domstol.dk',
        eanno: '5798000161399',
        address: 'Søndre Jernbanevej 18B',
        zipcode: '3400',
        city: 'Hillerød',
        id: '1115',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134416',
    },
    {
        courtId: '628bfd30-8d0c-4c24-9e31-5cbc5b0da6b9',
        name: 'Retten i Helsingør',
        phone: '49295920',
        email: 'foged.hel@domstol.dk',
        emailFogedret: 'foged.hel@domstol.dk',
        emailFogedretRevideretBPK: 'foged.hel@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.hel@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.hel@domstol.dk',
        eanno: '5798000161375',
        address: 'Prøvestensvej 50',
        zipcode: '3000',
        city: 'Helsingør',
        id: '1113',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134467',
    },
    {
        courtId: '2c1d8908-f27e-460c-bfdb-ebe4906dcc96',
        name: 'Retten i Lyngby',
        phone: '99684800',
        email: 'foged.lyn@domstol.dk',
        emailFogedret: 'foged.lyn@domstol.dk',
        emailFogedretRevideretBPK: 'foged.lyn@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.lyn@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.lyn@domstol.dk',
        eanno: '5798000161283',
        address: 'Lyngby Hovedgade 96',
        zipcode: '2800',
        city: 'Kongens Lyngby',
        id: '1104',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134513',
    },
    {
        courtId: 'c893d486-337c-407f-a2d8-2e53a14d7654',
        name: 'Retten i Glostrup',
        phone: '43231400',
        email: 'foged.glo@domstol.dk',
        emailFogedret: 'foged.glo@domstol.dk',
        emailFogedretRevideretBPK: 'foged.glo@domstol.dk',
        emailFogedretIndleveringBPK: 'nysag.glo@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'nysag.glo@domstol.dk',
        eanno: '5798000161337',
        address: 'Stationsparken 27',
        zipcode: '2600',
        city: 'Glostrup',
        id: '1109',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134572',
    },
    {
        courtId: 'bd7b4f49-c6a3-49f8-a2c3-4c8bfd6f4023',
        name: 'Retten på Frederiksberg',
        phone: '99685000',
        email: 'foged.frb@domstol.dk',
        emailFogedret: 'foged.frb@domstol.dk',
        emailFogedretRevideretBPK: 'foged.frb@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.frb@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.frb@domstol.dk',
        eanno: '5798000161269',
        address: 'Howitzvej 32',
        zipcode: '2000',
        city: 'Frederiksberg',
        id: '1102',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134688',
    },
    {
        courtId: 'fea41b5c-5600-4f8f-82a9-672ac2af4dfd',
        name: 'Københavns Byret',
        phone: '99687000',
        email: 'foged.kbh@domstol.dk',
        emailFogedret: 'foged.kbh@domstol.dk',
        emailFogedretRevideretBPK: 'foged.kbh@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.kbh@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.kbh@domstol.dk',
        eanno: '5798000161252',
        address: 'Hestemøllestræde 6',
        zipcode: '1464',
        city: 'København K',
        id: '1101',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134793',
    },
    {
        courtId: '592ca74c-3459-473c-996e-0e32ca7cb388',
        name: 'Retten på Bornholm',
        phone: '99688300',
        email: 'foged.bor@domstol.dk',
        emailFogedret: 'foged.bor@domstol.dk',
        emailFogedretRevideretBPK: 'foged.bor@domstol.dk',
        emailFogedretIndleveringBPK: 'foged.bor@domstol.dk',
        emailFogedretIndleveringFogedrekvisition: 'foged.bor@domstol.dk',
        eanno: '5798000161573',
        address: 'Damgade 4A',
        zipcode: '3700',
        city: 'Rønne',
        id: '1134',
        country: 'DK',
        registrationnumber: '0216',
        accountnumber: '4069134726',
    },
];
//# sourceMappingURL=denmark.js.map